<template>
    <div class="service-wrapper">
        <img src="/static/images/2500/2500@2x.png" alt="">
        <h5>2500在线客服</h5>
        <p>即将上线在线客服, 让沟通交流更方便, 7*16小时保障蔚来员工日常办公需求。</p>
        <div class="button" @click="order_func">对功能的心愿戳这里</div>
    </div>
</template>
<script>
export default {
    name:'message',
    data(){
        return{
            
        }
    },
    mounted() {},
    methods: {
        order_func(){
            this.$router.push({name:'feedback',params:{
                from:'orderData'
            }});
        }
    },
}
</script>
<style lang="scss" scoped>
    .service-wrapper{
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: j(30);
        box-sizing: border-box;
        img{
            width: j(750);
            height: j(750);
            margin-bottom: j(90);
        }
        h5{
            width: j(650);
            font-size: j(48);
            color: #363C54;
            font-weight: 700;
            margin-bottom: j(39);
        }
        p{
            width: j(650);
            flex:1;
            font-size: j(28);
            color:#363C54;
            font-weight: 400;
        }
        .button{
            width: j(650);
            height: j(90);
            line-height: j(90);
            background-color: #00BCBC;
            border-radius: j(45);
            font-size: j(32);
            color: #ffffff;
            text-align: center;
        }

    }
</style>



// WEBPACK FOOTER //
// src/views/2500/service.vue